<template>
  <ValidationObserver ref="form" v-slot="{ invalid }">
    <form @submit.prevent="onSubmit">
      <table class="table is-fullwidth">
        <tr>
          <td colspan="2">
            <!-- email -->
            <ValidationProvider
              name="attendant_email"
              rules="required|email|alreadyRegistered"
              v-slot="{ errors }"
            >
              <b-field
                :type="errors[0] ? 'is-danger' : ''"
                :message="errors[0]"
                label="Email"
                label-position="on-border"
                grouped
              >
                <b-input v-model="attendant.email" type="text"></b-input>
                <p class="control">
                  <b-button
                    :disabled="invalid"
                    native-type="submit"
                    class="button is-info"
                    >Convidar</b-button
                  >
                </p>
              </b-field>
            </ValidationProvider>
          </td>
        </tr>
        <tr v-for="attendant in attendants" :key="attendant._id">
          <td>
            {{ attendant.name }}
            <b-tag v-show="!attendant.name" icon="account-check-outline">{{
              attendant.email
            }}</b-tag>
          </td>
          <td>
            <a @click.prevent="removeAttendant(attendant._id)">
              <b-icon icon="trash-can-outline" class="button has-text-danger">
              </b-icon>
            </a>
          </td>
        </tr>
      </table>
    </form>
  </ValidationObserver>
</template>
<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { email } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Esse campo é requerido",
});
extend("email", {
  ...email,
  message: "Email inválido",
});

export default {
  name: "OfficeAttendants",
  props: ["officeId", "attendants"],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      attendant: {},
    };
  },
  mounted() {
    extend("alreadyRegistered", {
      validate: (email) => !this.attendants.find((f) => f.email == email),
      message: "Já registrado",
    });
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.$http
          .put(`office/attendant/add/${this.officeId}`, this.attendant)
          .then((response) => {
            this.attendant._id = response.data._id;
            this.attendants.push(this.attendant);
            this.$refs.form.reset();
            this.attendant = {};
          });

        //this.$refs.form.reset();
      });
    },

    removeAttendant(attendantId) {
      this.$http
        .put(`office/attendant/del/${this.officeId}`, { _id: attendantId })
        .then(() => {
          let attendants = this.attendants.filter((f) => f._id != attendantId);
          this.$emit("updateAttendants", attendants);
        });
    },
  },
};
</script>
